<template>
  <div>
    <!-- 🔹 Router container -->
    <router-view />
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue'
import { useAppStore } from '@/stores/useAppStore'

const app = useAppStore()

// 🧭 Funcție pentru aplicarea culorilor dinamice din API
const applyThemeColors = () => {
  const primary = app.school?.primary_color || '#2563eb' // fallback blue-600
  const accent = app.school?.accent_color || '#38bdf8'   // fallback sky-400

  document.documentElement.style.setProperty('--primary-color', primary)
  document.documentElement.style.setProperty('--accent-color', accent)
}

// 🌙 Funcție pentru dark mode
const applyDarkMode = () => {
  document.documentElement.classList.toggle('dark', app.darkMode)
}

// 🚀 Când aplicația pornește
onMounted(async () => {
  await app.fetchSchoolDetails() // încărcăm o singură dată
  applyThemeColors()
  applyDarkMode()
})

// 🔁 Reaplicăm dacă școala sau dark mode-ul se schimbă
watch(
  () => app.school,
  () => applyThemeColors(),
  { deep: true }
)

watch(
  () => app.darkMode,
  () => applyDarkMode()
)
</script>

<style>
/* 🎨 Variabile CSS globale controlate de API */
:root {
  --primary-color: #2563eb;
  --accent-color: #38bdf8;
}
/* Când aplicația e în dark mode, spune-i browserului să folosească elemente native dark */
html.dark {
  color-scheme: dark;
}

html.light {
  color-scheme: light;
}
/* Forțează opțiunile din select să fie dark când HTML-ul are clasa .dark */
html.dark select option {
  background-color: #1e293b; /* Culoarea de fundal (ex: slate-800) */
  color: #f1f5f9;            /* Culoarea textului (ex: slate-100) */
}

/* Opțional: o nuanță un pic mai diferită când opțiunea e selectată/cu focus (nu merge pe toate browserele, dar ajută) */
html.dark select option:checked {
  background-color: var(--primary-color);
  color: #ffffff;
}
/* ✅ Clase utilitare pentru ușurință */
.text-primary {
  color: var(--primary-color);
}
.bg-primary {
  background-color: var(--primary-color);
}
.border-primary {
  border-color: var(--primary-color);
}

.text-accent {
  color: var(--accent-color);
}
.bg-accent {
  background-color: var(--accent-color);
}
.border-accent {
  border-color: var(--accent-color);
}

/* Hover-uri comune */
.hover\:text-primary:hover {
  color: var(--primary-color);
}
.hover\:bg-primary:hover {
  background-color: var(--primary-color);
}

/* 🌙 Dark mode styling global */
html.dark {
  background-color: #0f172a;
  color-scheme: dark;
}
</style>
